

document.addEventListener('DOMContentLoaded', function () {
  const design = document.querySelector('.m_design2');
  const comparisonBar = document.querySelector('.m_compare_products_bar_wrapper');

// 🔁 Utility: Show/hide elements by tag matching
function filterElementsByTags(selectedTags = []) {
  document.querySelectorAll('.m_add_to_compare, .m_product_comparison_wrapper').forEach(el => {
    const isCompareBox = el.classList.contains('m_add_to_compare');
    const elTags = el.dataset.tags ? el.dataset.tags.split(',').map(tag => tag.trim()) : [];
    const hasMatch = selectedTags.some(tag => elTags.includes(tag));

    if (isCompareBox) {
      el.style.display = hasMatch ? 'flex' : 'none';
    } else {
      el.style.display = hasMatch ? 'block' : 'none';
    }
  });
}

// 🔁 Utility: Reset visibility
function showAllCompareElements() {
  document.querySelectorAll('.m_add_to_compare, .m_product_comparison_wrapper').forEach(el => {
    if (el.classList.contains('m_add_to_compare')) {
      el.style.display = 'flex';
    } else {
      el.style.display = 'block';
    }
  });
}

function attachCompareCheckboxes() {
  document.querySelectorAll('.m_add_to_compare:not([data-initialized])').forEach(element => {
    const productHandle = element.getAttribute('data-handle');
    const productId = element.getAttribute('data-id');
    const variantId = element.getAttribute('data-variant-id') || null;
    const title = element.getAttribute('data-title');
    const price = element.getAttribute('data-price');
    const image = element.getAttribute('data-image');
    const dataTags = element.getAttribute('data-tags');

    let comparisonData = [];
    try {
      comparisonData = JSON.parse(element.getAttribute('data-comparison')) || [];
    } catch (e) {
      console.error(`Invalid data-comparison for: ${productHandle}`, e);
    }

    const metafields = comparisonData.reduce((acc, item) => {
      if (typeof item === 'string' && item.includes(':')) {
        const [key, value] = item.split(':').map(str => str.trim());
        acc[key] = value;
      }
      return acc;
    }, {});

    const compareJSON = {
      id: productId,
      variant_id: variantId,
      title,
      handle: productHandle,
      image,
      price,
      "data-tags": dataTags,
      metafields
    };

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'addToCompare';
    checkbox.id = `compare-${productId}`;
    checkbox.setAttribute('data-product-json', JSON.stringify(compareJSON));
    checkbox.setAttribute('data-product-id', productId);

    if (Object.keys(metafields).length === 0) {
      checkbox.classList.add('nodata');
      checkbox.disabled = true;
    }

    const label = document.createElement('label');
    label.setAttribute('for', `compare-${productId}`);
    label.innerHTML += `
      <svg class="mx_compare_svgs" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3Zm5.25 1.5h-2.5v11h2.5v-11Zm1.5 0v11H11a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 11 1.5H9.75ZM3 1.5h1.25v11H3A1.5 1.5 0 0 1 1.5 11V3A1.5 1.5 0 0 1 3 1.5Z" fill="black"/>
      </svg>Compare`;

    element.appendChild(checkbox);
    element.appendChild(label);
    element.setAttribute('data-initialized', 'true');
  });
}

// Initial attach on page load
attachCompareCheckboxes();

// Re-attach on tab click (for dynamic tab sections)
// Re-attach on tab click (for dynamic tab sections)
document.querySelectorAll('.tabs__btn').forEach(tab => {
  tab.addEventListener('click', () => {
    setTimeout(runCompareUISetup, 100);
  });
});

// ✅ Utility function to re-run everything
function runCompareUISetup() {
  attachCompareCheckboxes();
  updatePopupContent();

  const compareArray = JSON.parse(localStorage.getItem('compareArray')) || [];

  if (compareArray.length > 0) {
    const firstTags = (compareArray[0]["data-tags"] || '').split(',').map(t => t.trim());
    filterElementsByTags(firstTags);
  } else {
    showAllCompareElements();
  }
}

// ✅ Observe changes inside `.collection__toolbar`
const targetToolbar = document.querySelector('.collection__toolbar');
if (targetToolbar) {
  const observer = new MutationObserver((mutationsList, observer) => {
    // Run logic when inner content of toolbar changes
    runCompareUISetup();
  });

  observer.observe(targetToolbar, {
    childList: true,
    subtree: true
  });
}


  function updatePopupContent() {
    const compareArray = JSON.parse(localStorage.getItem('compareArray')) || [];
    const compareButton = document.querySelector('.m_compare_product_btn');
    const compareButtonForBar = document.querySelector('.m_compare_products_bar_wrapper .m_compare_product_btn');

    const renderProducts = compareArray.map(product => `
      <div class="compare-product" data-product-id="${product.id}">
        ${design ? `
          <img src="${product.image}" alt="${product.title}">
          <div class="compare_product_info">
            <div class="compare_prodTitle">${product.title}</div>
            <div class="compare_prodPrice">${product.price}</div>
            <button class="remove-product">Remove</button>
          </div>` :
          `<button class="remove-product">&#10005;</button>
          <a href="${product.handle}" target="_blank">
            <img src="${product.image}" alt="${product.title}">
            <div class="compare_prodTitle">${product.title}</div>
            <div class="compare_prodPrice">${product.price}</div>
          </a>`}
      </div>
    `).join('');

    if (design) {
      document.querySelector('.m_compare_products_content').innerHTML = renderProducts;
      compareButtonForBar.classList.toggle('disabledButton', compareArray.length <= 1);
    } else {
      document.querySelector('.m_compare_products_popup_content').innerHTML = renderProducts;
      compareButton.classList.toggle('disabledButton', compareArray.length <= 1);
    }

    document.querySelectorAll('input.addToCompare').forEach(input => {
      const productId = input.getAttribute('data-product-id');
      const isSelected = compareArray.some(p => p.id === productId);
      input.checked = isSelected;
      input.classList.toggle('activeCheckbox', isSelected);

      const isMax = compareArray.length >= 4 && !isSelected;
      input.disabled = isMax || input.classList.contains('nodata');
      input.classList.toggle('disabledCompare', isMax);
    });

    document.querySelector('.compare_count').textContent = compareArray.length;
    document.querySelector('.compare_count_wrapper').classList.toggle('hasCount', compareArray.length > 0);
    comparisonBar.classList.toggle('activeCompareBar', compareArray.length > 0);
  }

  function initTagFilteringOnLoad() {
    const compareArray = JSON.parse(localStorage.getItem('compareArray')) || [];
    if (compareArray.length === 0) {
      showAllCompareElements();
      return;
    }

    const firstProduct = compareArray[0];
    const firstTags = (firstProduct["data-tags"] || '').split(',').map(t => t.trim());
    filterElementsByTags(firstTags);
  }

  updatePopupContent();
  initTagFilteringOnLoad();

  let compareArray = JSON.parse(localStorage.getItem('compareArray')) || [];
  let count = compareArray.length;

  document.body.addEventListener('change', function (event) {
    if (event.target.classList.contains('addToCompare')) {
      const productJson = event.target.getAttribute('data-product-json');
      const product = JSON.parse(productJson);
      const productId = product.id;

      const clickedWrapper = event.target.closest('.m_add_to_compare, .m_product_comparison_wrapper, .m_none');
      const selectedTags = clickedWrapper?.dataset.tags ? clickedWrapper.dataset.tags.split(',').map(t => t.trim()) : [];

      if (compareArray.length === 0 && event.target.checked) {
        filterElementsByTags(selectedTags);
        const wrapper = clickedWrapper.closest('.m_product_comparison_wrapper') || clickedWrapper;
        wrapper.style.display = 'block';
      }

      if (event.target.checked) {
        if (compareArray.length < 4 && !compareArray.some(p => p.id === productId)) {
          compareArray.push(product);
          count++;
        } else {
          event.target.checked = false;
          alert('You can only compare up to 4 products.');
        }
      } else {
        compareArray = compareArray.filter(p => p.id !== productId);
        count--;
        if (compareArray.length === 0) {
          showAllCompareElements();
        }
      }

      localStorage.setItem('compareArray', JSON.stringify(compareArray));
      updatePopupContent();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('remove-product')) {
      const productId = event.target.closest('.compare-product')?.getAttribute('data-product-id');
      compareArray = compareArray.filter(p => String(p.id) !== String(productId));
      localStorage.setItem('compareArray', JSON.stringify(compareArray));
      count--;
      updatePopupContent();

      if (count === 0) {
        showAllCompareElements();
        if (design) {
          document.querySelector('.m_compare_products_content').innerHTML = 'Select upto 4 products to compare';
        } else {
          closePopup();
        }
      }
    }
  });

  document.querySelector('.m_compare_products_floating_button')?.addEventListener('click', function () {
    const popup = document.querySelector('.m_compare_products_main');
    popup.style.display = 'block';
    setTimeout(() => {
      popup.classList.add('show');
      popup.style.visibility = 'visible';
    }, 10);
  });

  document.querySelectorAll('.m_compare_products_popup_close, .m_compare_products_overlay').forEach(el => {
    el.addEventListener('click', closePopup);
  });

  function closePopup() {
    const popup = document.querySelector('.m_compare_products_main');
    popup.classList.remove('show');
    setTimeout(() => {
      popup.style.visibility = 'hidden';
      popup.style.display = 'none';
    }, 300);
  }

  const clpopup = document.querySelector('.m_compare_products_popup');
  document.querySelectorAll('.m_compare_products_main').forEach(popupElement => {
    popupElement.addEventListener("click", function (event) {
      if (!clpopup.contains(event.target)) {
        closePopup();
      }
    });
  });

  document.querySelector('.cancelComparison')?.addEventListener('click', () => {
    comparisonBar.classList.remove('activeCompareBar');
    localStorage.removeItem('compareArray');
    compareArray = [];
    count = 0;
    updatePopupContent();
    showAllCompareElements();
    document.querySelector('.m_compare_products_content').innerHTML = 'Select upto 4 products to compare';
  });
});




